<template>
  <div class='selector'>
    <div class='selector-container'>
      <div class='selector-arrow selector-arrow_left' @click='prevRoom()'></div>
      <div class="selector-txt-container selector-txt-services">
        <div class='selector-ico'>
          <i class="el-icon-menu"></i>
        </div>
        <div id='serviceToPrint' class='selector-txt'>
          {{ getCurrentRoom }}
        </div>
        <el-select v-model="valueSelect" value-key="id" @change="setSelectedRoomLocal">
          <el-option v-for="item in getRooms" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class='selector-arrow selector-arrow_right' @click='nextRoom()'></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'RoomNav',
  data() {
    return {
      valueSelect: 'all'
    }
  },
  computed: {
    ...mapGetters({
      getSelectedRoom: 'newRooms/getSelectedRoom',
      getRoomsDatas: 'newRooms/getRoomsDatas'
    }),
    getCurrentRoom: function () {
      if (this.getSelectedRoom) return this.getRoomsDatas[this.getSelectedRoom].name
      else return 'Toutes les salles'
    },
    getRooms: function () {
      let rooms = []
      rooms.push({
        id: 'all',
        name: 'Toutes les salles'
      })
      if (this.getRoomsDatas) {
        Object.entries(this.getRoomsDatas).forEach(r => {
          rooms.push(r[1])
        })
      }
      return rooms
    }
  },
  watch: {
    'getSelectedRoom': function (val, oldVal) {
      this.valueSelect = val
    }
  },
  methods: {
    ...mapMutations({
      setSelectedRoom: 'newRooms/setSelectedRoom'
    }),
    setSelectedRoomLocal: function (selected) {
      if (selected === 'all') this.setSelectedRoom('')
      else this.setSelectedRoom(selected)
    },
    prevRoom: function () {
      let indexSelected = 0
      let currentIndex = this.getRooms.findIndex(r => {
        return r.id === this.getSelectedRoom
      })
      if (currentIndex <= 0) indexSelected = this.getRooms.length - 1
      else indexSelected = currentIndex - 1

      this.setSelectedRoomLocal(this.getRooms[indexSelected].id)
    },
    nextRoom: function () {
      let indexSelected = 0
      let currentIndex = this.getRooms.findIndex(r => r.id === this.getSelectedRoom)

      if (currentIndex === this.getRooms.length - 1) indexSelected = 0
      else if (currentIndex < 0) indexSelected = 1
      else indexSelected = currentIndex + 1

      this.setSelectedRoomLocal(this.getRooms[indexSelected].id)
    }
  }
}
</script>

<style lang="scss"></style>
